module.exports = __webpack_public_path__ + "static/media/pf_item_1.a43bee09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_1.jpg
// module id = 48
// module chunks = 0